import { Button, Select } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { getPopupContainer } from '../../../../helpers/popUp';
import { filterSelectOptions } from '../../../DynamicFormNew/helper';
import { useModule } from '../../../../helpers/user';

const Style = styled.div`
  display: flex;
  gap: 20px;
  padding: 0 var(--size-lg);

  .section {
    display: flex;
    flex-direction: column;

    .flex-row {
      gap: 12px;

      label {
        font-weight: 500;
        font-size: 14px;
        color: #101828;
        margin-bottom: 0px;
      }

      img {
        width: 18px;
      }
    }
  }

  .ant-btn {
    border-radius: 8px;
  }
`;

const ItemToFocus = ({
  selectedItem = null,
  items = [],
  t = (s) => s,
  onChange = () => { },
  label = 'Mine Site',
  source = '/assets/images/dashboard/select-icons/mine-site.svg',
  type = 'scl',
}) => {
  const { mod } = useModule();

  return (
    <Style>
      <div className="section flex-1">
        <div className="flex-row">
          <div className="flex-c jus-c">
            <img alt="img" src={source} />
          </div>
          <div className="flex-c jus-c">
            <label>{t(label)}</label>
          </div>
          <Select
            {...getPopupContainer()}
            onChange={onChange}
            style={{ width: 200 }}
            value={selectedItem}
            showSearch
            filterOption={filterSelectOptions}
          >
            {items.map((item) => (
              <Select.Option
                key={`select-${item.datastakeId}`}
                value={item.datastakeId}
              >
                {item.name}
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>
      <div className="section">
        {selectedItem ? (
          <a
            href={`/app/${mod}/analysis/${type}/${selectedItem}`}
            target="_blank"
            rel="noreferrer"
          >
            <Button type="primary">
              {t('View')}
            </Button>
          </a>
        ) : (
          <Button type="primary" disabled>
            {t('View')}
          </Button>
        )}
      </div>
    </Style>
  );
};

export default ItemToFocus;
